import { Form, InputNumber } from "antd";
import type React from "react";
import type { MemberAttribute } from "../../../../../shared/types/member.types";
import { useMemberAttributeContext } from "../../../providers/MemberAttributeContext";
import { FilterWrapper } from "../FilterWrapper";
import type { MemberAttributeFilterConfig } from "../types";

export const RangedNumberFilter: React.FC<{
	memberAttribute?: MemberAttribute;
	config?: MemberAttributeFilterConfig;
}> = (props) => {
	const memberAttributeContext = useMemberAttributeContext();
	const memberAttribute =
		props.memberAttribute || memberAttributeContext.memberAttribute;
	const config = props.config || memberAttributeContext.config;

	if (!memberAttribute.memberAttributeId) return null;
	const range = [
		{ value: "Min", label: "最低", placeholder: "例：0" },
		{ value: "Max", label: "最高", placeholder: "例：500" },
	];

	if (config.layout === "vertical") {
		return (
			<FilterWrapper
				key={`${memberAttribute.label}${memberAttribute.memberAttributeId}`}
				config={config}
				itemKey={`${memberAttribute.label}${memberAttribute.memberAttributeId}`}
			>
				<Form.Item className="mb-0">
					{range.map((bound, index) => (
						<Form.Item
							help={`${bound.label}${memberAttribute.label}`}
							name={`memberAttributeFilter${memberAttribute.memberAttributeId}${bound.value}`}
							key={`${memberAttribute.memberAttributeId}${bound.value}_${index}`}
							className={`inline-block ${index !== range.length - 1 ? "mr-2" : ""} mb-4`}
							style={{ width: "calc(50% - 0.25rem)" }}
						>
							<InputNumber placeholder={bound.placeholder} className="w-full" />
						</Form.Item>
					))}
				</Form.Item>
			</FilterWrapper>
		);
	}

	return (
		<>
			{range.map((bound, index) => (
				<FilterWrapper
					key={`${memberAttribute.label}${memberAttribute.memberAttributeId}_${index}`}
					config={config}
					itemKey={`${memberAttribute.label}${memberAttribute.memberAttributeId}_${index}`}
				>
					<Form.Item
						help={
							config.showHelpText
								? `${bound.label}${memberAttribute.label}`
								: undefined
						}
						name={`memberAttributeFilter${memberAttribute.memberAttributeId}${bound.value}`}
						className="mb-4 w-full"
					>
						<InputNumber placeholder={bound.placeholder} className="w-full" />
					</Form.Item>
				</FilterWrapper>
			))}
		</>
	);
};
